var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"name":"switch","value":_vm.value,"labels":_vm.messages,"width":_vm.width,"color":_vm.colors,"sync":""},on:{"change":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }